import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatDistanceToNow } from 'date-fns';

const ConversationList = ({ conversations, activeConversationId, onSelectConversation, familyMembers }) => {
  const formatTime = (timestamp) => {
    try {
      return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
    } catch {
      return 'Recently';
    }
  };

  const getMemberColor = (senderId) => {
    const member = familyMembers?.find(m => m?.id === senderId);
    return member?.color || '#6B7280';
  };

  if (!conversations || conversations?.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8 text-center">
        <div>
          <Icon name="message-square" size={32} className="mx-auto mb-2 text-muted-foreground" />
          <p className="text-sm text-muted-foreground">
            No conversations yet
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto">
      {conversations?.map((conversation) => {
        const isActive = conversation?.id === activeConversationId;
        const hasUnread = conversation?.unreadCount > 0;

        return (
          <button
            key={conversation?.id}
            onClick={() => onSelectConversation(conversation?.id)}
            className={`w-full p-4 border-b border-border text-left transition-colors hover:bg-accent/50 ${
              isActive ? 'bg-accent' : ''
            }`}
          >
            <div className="flex items-start justify-between mb-1">
              <h3 className={`font-semibold text-foreground ${
                hasUnread ? 'font-bold' : ''
              }`}>
                {conversation?.title}
              </h3>
              {hasUnread && (
                <span className="bg-primary text-primary-foreground text-xs font-semibold px-2 py-0.5 rounded-full">
                  {conversation?.unreadCount}
                </span>
              )}
            </div>
            
            <p className={`text-sm text-muted-foreground line-clamp-2 mb-1 ${
              hasUnread ? 'font-medium text-foreground' : ''
            }`}>
              {conversation?.lastMessage || 'No messages yet'}
            </p>
            
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">
                {formatTime(conversation?.lastMessageTime)}
              </span>
              {conversation?.messages?.length > 0 && (
                <div className="flex items-center gap-1">
                  <Icon name="message-circle" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    {conversation?.messages?.length}
                  </span>
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ConversationList;